<template>
  <div class="page-info">
    <div class="page-info-text">
      <h3 v-html="$t(`${namespace}.titleHowToRequest`)" class="mb-1" />
      <p v-html="$t(`${namespace}.textHowToRequest`)" />
    </div>

    <div class="page-info__button">
      <Button @click="requestToken">
        {{ $t(`${namespace}.btnRequest`) }}
      </Button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HowToRequestInfo',
  data () {
    return {
      namespace: 'Views.RequestTokenPage'
    }
  },
  methods: {
    requestToken () {
      this.$emit('showRequestTokenForm')
    }
  }
}
</script>
<style lang="scss" scoped>
.page-info {
  padding: 16px 8px;

  .page-info__button {
    padding-top: 16px;
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
</style>
